/** @jsx jsx */

import { css, jsx } from '@emotion/core';
import { Colors } from '@zapier/design-system';

const Styles = {
  progress: css`
    display: inline-block;
    vertical-align: top;
  `,
  svg: css`
    display: block;
    overflow: visible;
  `,
  circle: css`
    fill: none;
    stroke: ${Colors.GrayWarm3};
  `,
  valueBarBase: barColor =>
    css`
      fill: none;
      stroke-linecap: round;
      transition: stroke-dashoffset 2s cubic-bezier(0.19, 1, 0.22, 1),
        stroke 2s ease-out;
      stroke: ${barColor};
    `,
};

type ProgressCircleProps = {
  /** The title of the graph. */
  title?: string;
  /** Percent of the value (0-100). */
  percent: number;
  /** Color of the value bar. */
  barColor?: string;
  /** Height of the graph. */
  height?: number;
};

const ProgressCircle = (props: ProgressCircleProps) => {
  const [diameter, barWidth, valueBarWidth] = [120, 5, 7];
  const center = diameter / 2;
  const radius = diameter / 2 - barWidth / 2;
  const circleProps = {
    cx: center,
    cy: center,
    r: radius,
  };
  const svgStyle = {
    transform: `rotate(90deg)`,
  };
  const valueBarCss = Styles.valueBarBase(props.barColor);

  const circ = Math.PI * radius * 2;
  const valueBarStyle = {
    strokeDashoffset: (1 - props.percent / 100) * circ,
    strokeDasharray: circ,
  };

  const sizeGraph = props.height || diameter;
  return (
    <div css={Styles.progress} title={props.title || `${props.percent}%`}>
      <svg
        css={Styles.svg}
        height={sizeGraph}
        style={svgStyle}
        viewBox={`0 0 ${diameter} ${diameter}`}
        width={sizeGraph}
      >
        <circle {...circleProps} css={Styles.circle} strokeWidth={barWidth} />
        <circle
          {...circleProps}
          css={valueBarCss}
          strokeWidth={valueBarWidth}
          style={valueBarStyle}
        />
      </svg>
    </div>
  );
};

ProgressCircle.defaultProps = {
  barColor: Colors.GrayWarm4,
};

export default ProgressCircle;
